<template>
  <v-row align="center" justify="center" class="ma-0">
    <v-col>
      <!-- <v-row
        v-if="eventDetails.Type === 'Repetitive' ||
          eventDetails.Type === 'Tour' ||
          eventDetails.Type === 'FlexEvent' ||
          eventDetails.Type === 'Fixed'"
        justify="center"
        class="ma-0"
      >
        <v-col cols="12" md="8" lg="6">
          <v-btn
            :disabled="!eventDetails.Bookable"
            block
            depressed
            @click="goToBookingDetails"
            color="primary"
          >{{$translate('BOOK')}}</v-btn>
        </v-col>
      </v-row> -->

      <EventDetailsInfo :eventDetails="eventDetails" class="mt-4" />
    </v-col>
  </v-row>
</template>

<script>
import EventDetailsInfo from './EventDetailsInfo.vue';

export default {
  name: 'EventDetailsTickets',
  components: {
    EventDetailsInfo,
  },
  props: {
    btnSize: Object,
    eventDetails: Object,
  },
  data() {
    return {};
  },
  methods: {
    goToBookingDetails() {
      this.$emit('bookButtonPressed');
    },
  },
};
</script>
